import {
  LANDING_PAGE_LAYOUT_THEMES,
  PAPER_BROWSER_LAYOUT_THEMES,
  layoutSize,
} from '../mixins/responsive';
import FlexboxGridThemes from '../themes/FlexboxGridThemes';

// DOES LANDING_PAGE_THEME_MAP ONLY RIGHT NOW
const getPageSizeLayoutTheme = ({ layoutSize, isLandingPage = true }) => {
  let GridThemeMap = isLandingPage
    ? LANDING_PAGE_LAYOUT_THEMES
    : PAPER_BROWSER_LAYOUT_THEMES;

  return FlexboxGridThemes[GridThemeMap[layoutSize]];
};

export default getPageSizeLayoutTheme;
